/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description nearby constants
 */

export const START_FETCHING_NEARBY = '@@nzr/Detail/START_FETCHING_NEARBY'
export const CLEAR_NEARBY = '@@nzr/Detail/CLEAR_NEARBY'
export const DONE_FETCHING_NEARBY = '@@nzr/Detail/DONE_FETCHING_NEARBY'
export const ERROR_FETCHING_NEARBY = '@@nzr/Detail/ERROR_FETCHING_NEARBY'
export const RECEIVE_NEARBY = '@@nzr/Detail/RECEIVE_NEARBY'
